import { render, staticRenderFns } from "./ModalAfterCreate.vue?vue&type=template&id=5240dbee"
import script from "./ModalAfterCreate.vue?vue&type=script&lang=js"
export * from "./ModalAfterCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports